<ngx-ui-loader></ngx-ui-loader>
<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <h5>Problem Resolution</h5>
    <div class="row">
        <div class="col-md-12">
            <div class="example-button-row">
                <button mat-raised-button color="primary" (click)="addResolution('add','')">Add Maintainance Resolution</button>
              </div>
              <div fxLayout fxLayoutAlign="center center">
                <mat-form-field fxFlex="40%">
                  <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
                </mat-form-field>
              </div>
              <div class="table-container">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
              
                  <!-- Sitename Column -->
                  <ng-container matColumnDef="sitename">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
                    <td mat-cell *matCellDef="let element"> {{ element.sitename }} </td>
                  </ng-container>
              
                  <!-- Transformer ID Column -->
                  <ng-container matColumnDef="transformerid">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Transformer ID </th>
                    <td mat-cell *matCellDef="let element"> {{ element.transformerid }} </td>
                  </ng-container>
              
                 
                  <!-- Date Column -->
                  <ng-container matColumnDef="currentdatetime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.currentdatetime | date:'short' }} </td>
                  </ng-container>
              
                 
                  <!-- Engineer Name Column -->
                  <ng-container matColumnDef="engineername">
                    <th mat-header-cell *matHeaderCellDef> Engineer Name </th>
                    <td mat-cell *matCellDef="let element"> {{ element.engineername }} </td>
                  </ng-container>
                 
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                    <td mat-cell *matCellDef="let element">
                      <button mat-icon-button color="warn" (click)="deleteData(element)">
                        <mat-icon class="mat-18">delete</mat-icon>
                    </button>
                        <button (click)="addResolution('edit',element)" mat-icon-button color="primary" >
                          <mat-icon class="mat-18">visibility</mat-icon>
                      </button>
                    </td>
                  </ng-container>
    
                  <!-- Header and Row Definition -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              
                <!-- Pagination -->
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
              </div>
        </div>

    </div>
    </div>
